import React from 'react';

const SolIcon = (props) => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="30" height="20" rx="2" fill="black"/>
    <g clipPath="url(#clip0_6867_4585)">
      <path d="M9.83153 13.158C9.92393 13.0656 10.051 13.0117 10.1857 13.0117H22.4052C22.6285 13.0117 22.7401 13.2812 22.5823 13.4391L20.1684 15.8529C20.076 15.9453 19.949 15.9992 19.8142 15.9992H7.59477C7.37148 15.9992 7.25983 15.7297 7.41767 15.5719L9.83153 13.158Z" fill="url(#paint0_linear_6867_4585)"/>
      <path d="M9.82958 4.14629C9.92583 4.0539 10.0529 4 10.1838 4H22.4032C22.6265 4 22.7381 4.26949 22.5803 4.42733L20.1664 6.84119C20.074 6.93359 19.947 6.98749 19.8123 6.98749H7.59281C7.36952 6.98749 7.25788 6.718 7.41572 6.56015L9.82958 4.14629Z" fill="url(#paint1_linear_6867_4585)"/>
      <path d="M20.1684 8.62383C20.076 8.53144 19.949 8.47754 19.8142 8.47754H7.59477C7.37148 8.47754 7.25983 8.74703 7.41767 8.90487L9.83153 11.3187C9.92393 11.4111 10.051 11.465 10.1857 11.465H22.4052C22.6285 11.465 22.7401 11.1955 22.5823 11.0377L20.1684 8.62383Z" fill="url(#paint2_linear_6867_4585)"/>
    </g>
    <defs>
      <linearGradient id="paint0_linear_6867_4585" x1="21.2378" y1="2.55723" x2="12.781" y2="18.7555" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00FFA3"/>
        <stop offset="1" stopColor="#DC1FFF"/>
      </linearGradient>
      <linearGradient id="paint1_linear_6867_4585" x1="17.5381" y1="0.627473" x2="9.08128" y2="16.8257" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00FFA3"/>
        <stop offset="1" stopColor="#DC1FFF"/>
      </linearGradient>
      <linearGradient id="paint2_linear_6867_4585" x1="19.3772" y1="1.58676" x2="10.9204" y2="17.785" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00FFA3"/>
        <stop offset="1" stopColor="#DC1FFF"/>
      </linearGradient>
      <clipPath id="clip0_6867_4585">
        <rect width="15.3109" height="12" fill="white" transform="translate(7.34375 4)"/>
      </clipPath>
    </defs>
  </svg>

);

export default SolIcon;
